// ----------------------------------------------------------------------------
// Snippet: Menu
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var MENU_LIST_SELECTOR = '.menu__list';
var MENU_DROPDOWN_SELECTOR = '.menu__item--dropdown';
var MENU_DROPDOWN_BUTTON_SELECTOR = '.menu__item--dropdown > .dropdown__icon';
var MENU_DROPDOWN_ITEM_SELECTOR = '.dropdown__item';
var MENU_EMPTY_LINK_SELECTOR = '.menu__item--dropdown > .menu__link--empty';
var MENU_LINK_SELECTOR = '.menu__link';
var MENU_DROPDOWN_LINK_SELECTOR = '.dropdown__link';
var PREDICTIVE_SEARCH_SELECTOR = '#predictive-search';

// Classes
var MENU_DROPDOWN_BUTTON_CLASS = 'dropdown__icon';
var MENU_DROPDOWN_LINK_CLASS = 'dropdown__link';
var OPEN_CLASS = 'js--is-open';
var JS_BOUND_CLASS = 'js--bound';

// -------------------------------------
// Helpers
// -------------------------------------

function initMenuDropdowns() {
  var dropdownButtons = document.querySelectorAll(MENU_DROPDOWN_BUTTON_SELECTOR);
  var dropdownLinks = document.querySelectorAll(MENU_DROPDOWN_LINK_SELECTOR);
  var emptyLinks = document.querySelectorAll(MENU_EMPTY_LINK_SELECTOR);
  dropdownButtons.forEach(function (button) {
    button.addEventListener('click', handleClick);
    button.addEventListener('keydown', handleKeydown);
  });
  dropdownLinks.forEach(function (link) {
    link.addEventListener('keydown', handleKeydown);
  });
  emptyLinks.forEach(function (link) {
    link.addEventListener('click', handleEmptyLinks);
    link.addEventListener('keydown', handleEmptyLinks);
  });
  hoverMenu();
}
function handleClick(event) {
  handleDropdown(event.currentTarget);
}
function handleKeydown(event) {
  var $this = event.currentTarget;
  var key = event.key;
  if ($this.classList.contains(MENU_DROPDOWN_BUTTON_CLASS) && key === 'Enter') {
    handleDropdown(event.currentTarget);
  } else if ($this.classList.contains(MENU_DROPDOWN_LINK_CLASS) && key === 'Tab') {
    var parentDropdown = $this.closest(MENU_DROPDOWN_ITEM_SELECTOR);
    var nextItem = parentDropdown.nextElementSibling;
    var prevItem = parentDropdown.previousElementSibling;
    if (event.shiftKey && prevItem === null || nextItem === null) {
      closeMenu(parentDropdown);
    }
  }
}
function handleDropdown(button) {
  var dropdown = button.closest(MENU_DROPDOWN_SELECTOR);
  if (dropdown.classList.contains(OPEN_CLASS)) {
    closeMenu(dropdown);
  } else {
    closeAllMenus(dropdown);
    openMenu(dropdown);
  }
}
function handleEmptyLinks(event) {
  var dropdown = event.currentTarget.closest(MENU_DROPDOWN_SELECTOR);
  event.preventDefault();
  closeMenu(dropdown);
}
function openMenu(dropdown) {
  var predictiveSearch = document.querySelector(PREDICTIVE_SEARCH_SELECTOR);
  var menuLink = dropdown.querySelector(MENU_LINK_SELECTOR);
  closeAllMenus(dropdown);
  dropdown.classList.add(OPEN_CLASS);
  menuLink.setAttribute('aria-expanded', 'true');
  predictiveSearch.style.display = 'none';
}
function closeMenu(dropdown) {
  var parentDropdown = dropdown.closest(MENU_DROPDOWN_SELECTOR);
  var menuLink = dropdown.querySelector(MENU_LINK_SELECTOR);
  parentDropdown.classList.remove(OPEN_CLASS);
  menuLink.setAttribute('aria-expanded', 'false');
}
function closeAllMenus(dropdown) {
  var allDropdowns = dropdown.closest(MENU_LIST_SELECTOR).querySelectorAll(MENU_DROPDOWN_SELECTOR);
  var currentMenuLink = dropdown.querySelector(MENU_LINK_SELECTOR);
  dropdown.classList.remove(OPEN_CLASS);
  currentMenuLink.setAttribute('aria-expanded', 'false');
  removeClassFromElements(allDropdowns, OPEN_CLASS);
  allDropdowns.forEach(function (dropdown) {
    var menuLink = dropdown.querySelector(MENU_LINK_SELECTOR);
    menuLink.setAttribute('aria-expanded', 'false');
  });
}
function hoverMenu() {
  var desktopMedia = window.matchMedia('(min-width: 1024px)');
  var dropdowns = document.querySelectorAll(MENU_DROPDOWN_SELECTOR);
  dropdowns.forEach(function (dropdown) {
    if (desktopMedia.matches) {
      dropdown.classList.add(JS_BOUND_CLASS);
      dropdown.addEventListener('mouseenter', allowHoverOnMenu);
      dropdown.addEventListener('mouseleave', allowHoverOnMenu);
    } else {
      dropdown.classList.remove(JS_BOUND_CLASS);
      dropdown.removeEventListener('mouseenter', allowHoverOnMenu);
      dropdown.removeEventListener('mouseleave', allowHoverOnMenu);
    }
  });
}
function allowHoverOnMenu(event) {
  var $this = event.currentTarget;
  var menuLink = $this.querySelector(MENU_LINK_SELECTOR);
  event.preventDefault();
  if (event.type === 'mouseenter') {
    var predictiveSearch = document.querySelector(PREDICTIVE_SEARCH_SELECTOR);
    $this.classList.add(OPEN_CLASS);
    menuLink.setAttribute('aria-expanded', 'true');
    predictiveSearch.style.display = 'none';
  } else {
    $this.classList.remove(OPEN_CLASS);
    menuLink.setAttribute('aria-expanded', 'false');
  }
}
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  initMenuDropdowns();
});